import React from "react";
import qs from "query-string";
// import { useMutation } from "react-query";
import { useHistory } from "react-router";
import "./contact-list.css";

import Alert from "../alert/Alert";
// import { useGet } from "app/services/http-service";
// import { RECENT_RECHARGE } from "app/api/ApiEndpoints";
//import Searchinput from "app/components/search-input/Searchinput";
// import Loader from "app/loader/Loader";
import useAlertConfig from "app/hooks/useAlertConfig";
// import { Initial } from "react-initial";
// import { StoreContext } from "app/context/Store";
// import { NUMBER_FOR_RECHARGE } from "app/context/Types";

function ContactList() {
  const { alertConfig } = useAlertConfig(6);
  const history = useHistory();
  const { phoneNumber } = qs.parse(location.search);
  // const authToken = localStorage.getItem("tspAuthToken");
  const [searchQuery, setSearchQuery] = React.useState('');
  // const context = React.useContext(StoreContext);
  //const [mobileNumber, setMobileNumber] = React.useState(null);
 const [isVaildMobileNumber, setIsVaildMobileNumber] = React.useState(false);
 React.useEffect(()=>{
   if (phoneNumber) {
     setIsVaildMobileNumber(true);
     setSearchQuery(phoneNumber);
   }
 },[phoneNumber]);
  //  const {
  //   mutate: recentRechargeMutation,
  //   data: recentRechargeData,
  //   isSuccess: fetchedRecentRecharge,
  //   isLoading: recentRechargeDataLoading,
  // } = useMutation((data) => useGet(data),{
  //   onError:(error)=>{
  //    showFailureAlert(error.message ? error.message : "Something went wrong!");
  //   }
  // });

  const handleOnChange = (event) => {
    setSearchQuery(event.target.value);
    if(event.target.value.length === 10){
      setIsVaildMobileNumber(true);
    }
    else{
      setIsVaildMobileNumber(false);
    }
    //let selectedElement = document.getElementById("mobileNumberInput");
    // const userInputString = event.target.value;
    // const regexPhoneMobileNumber =
    //   // eslint-disable-next-line no-useless-escape
    //   /^(?:(?:\+|0{0,2})91(\s*|[\-])?|[0]?)?([6789]\d{2}([ -]?)\d{3}([ -]?)\d{4})$/;
    // setSearchQuery(event.target.value);
    // selectedElement?.addEventListener("keydown", function (e) {
    //   if (e.keyCode === 13) {
    //     if (regexPhoneMobileNumber?.test(userInputString) === false) {
    //       showFailureAlert("Invaild Phone Number");
    //     } else if (regexPhoneMobileNumber.test(userInputString) === true) {
    //       enteredPhoneValue(userInputString);
    //     }
    //   }
    // });
    // if (regexPhoneMobileNumber.test(userInputString) === true && userInputString.length === 10) {
    //   setMobileNumber(userInputString);
    // }
  };

  // const userFullName = React.useMemo(() => {
  //   if (userProfileData) {
  //     if (userProfileData?.firstName && userProfileData?.lastName !== null) {
  //       return userProfileData?.firstName + " " + userProfileData?.lastName;
  //     } else if (
  //       userProfileData?.firstName &&
  //       userProfileData?.lastName === null
  //     ) {
  //       return userProfileData?.firstName;
  //     } else {
  //       return userProfileData?.firstName;
  //     }
  //   }
  // }, [userProfileData]);

  // function enteredPhoneValue(userInputValue) {
  //   history.push(`/recharge/mobile/${userInputValue}`);
  // }

  const handleOnClick = () => {
    if (isVaildMobileNumber && searchQuery) {
      history.push(`/recharge/mobile/${searchQuery}`);
    }
  };

  const handleKeyDown =(event)=>{
    if(event.key === 'Enter'){
      if (isVaildMobileNumber && searchQuery) {
        history.push(`/recharge/mobile/${searchQuery}`);
      }
    }
  };

  // React.useEffect(() => {
  //   const queryParams = {
  //     fromPastDays: 30,
  //     page: 0,
  //     size: 10,
  //     sortAscending: true,
  //     sortingField: "paymentDate",
  //   };
  //   const body = {
  //     url: `${RECENT_RECHARGE}?${qs.stringify(queryParams)}`,
  //     token: authToken,
  //   };
  //   recentRechargeMutation(body);
  // }, [recentRechargeMutation]);

  // const navigateToPlansPage = (mobileNumber) => {
  //   context.dispatch({
  //     type: NUMBER_FOR_RECHARGE,
  //     payload: { ...context.state, rechargeNumber: mobileNumber },
  //   });
  // };

  return (
    <div>
      {alertConfig && (
        <Alert alertMessage={alertConfig.message} status={alertConfig.status} />
      )}
      {/* <Searchinput
        id="mobileNumberInput"
        title="Type the Phone/Mobile number to Recharge"
        value={searchQuery}
        showSideArrrow={searchQuery?.length === 10 ? true : false}
        onChange={handleOnChange}
        onClick ={handleOnClick}
      /> */}

      <div className="search-input">
        <input value={searchQuery} onChange={(event) => { setSearchQuery(event.target.value); handleOnChange(event); }} 
          className="form-control" type="number" maxLength={10}  id="mobileNumberInput"
          placeholder="Type the Phone/Mobile number to Recharge" 
          onKeyDown={handleKeyDown}/>
        {
          isVaildMobileNumber && (
            <i className="material-icons" onClick={handleOnClick} >
              keyboard_arrow_right
            </i>
          )
        }
      </div>

      {
        !isVaildMobileNumber && searchQuery.length !== 0 && (
          <p className="text-danger">Invaild Mobile Number</p>
        )
      }
      {/* <div className="col-md-12 p-0">
        {recentRechargeDataLoading && <Loader loaderMessage="Loading..." />}

        {fetchedRecentRecharge &&
          recentRechargeData &&
          recentRechargeData?.content?.length === 0 && (
            <p className="text-center my-8">No Recent Recharge</p>
          )}
        {fetchedRecentRecharge &&
          recentRechargeData &&
          recentRechargeData?.content?.length !== 0 && (
            <h5 className="mt-4 mb-2 my-number font_600">Recent Recharge Number</h5>
          )}
        {false && (
          <div
            className="c-list cursor-pointer"
            onClick={() => {
              history.push(`/recharge/mobile/${userProfileData?.username}`);
              changeStep(2);
            }} 
          >
            <div className="name-circle">
              <p className="background-primary">
                {userFullName?.split(" ")?.shift()?.charAt(0) +
                  userFullName?.split(" ")?.pop()?.charAt(0)}
              </p>
            </div>
            <div className="name">
              <h3>{userFullName}</h3>
              <p>{userProfileData?.username}</p>
            </div>
          </div>
        )}
        {fetchedRecentRecharge &&
          recentRechargeData &&
          recentRechargeData?.content?.map((item, index) => {
            return (
              <div
                key={index}
                className="c-list"
                onClick={() =>{
                  navigateToPlansPage(item?.customerParams?.MobileNumber);
                  history.push(
                    `/recharge/${item?.customerParams?.OperatorCode}/${item?.customerParams?.CircleRefID}/plan?mobileNumber=${item?.customerParams?.MobileNumber}`,
                  );
                }
                }
              >
                <div className="name-circle cursor-pointer">
                  <Initial name={item?.billerName} charCount={2}  fontSize={14} fontWeight={600} height={30} width={30} />
                </div>
                <div className="name cursor-pointer">
                  <p>{item?.customerParams?.MobileNumber}</p>
                </div>
              </div>
            );
          })}
      </div> */}
    </div>
  );
}

export default ContactList;
